import React from "react";
import PropTypes from "prop-types";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./texteditor.css";

const CustomToolbar = () => (
  <div id="toolbar">
    <span className="toolbar-grp">
      <select className="ql-font">
        <option value="arial" selected>
          Arial
        </option>
        <option value="comic-sans">Comic Sans</option>
        <option value="courier-new">Courier New</option>
        <option value="georgia">Georgia</option>
        <option value="helvetica">Helvetica</option>
        <option value="lucida">Lucida</option>
      </select>
      <select className="ql-size">
        <option value="small" selected>
          Small
        </option>
        <option value="medium">Medium</option>
        <option value="large">Large</option>
      </select>
    </span>
    <span className="toolbar-grp">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
    </span>
    <span className="toolbar-grp">
      <button className="ql-header" value={1} />
      <button className="ql-header" value={2} />
    </span>
    <span className="toolbar-grp">
      <button className="ql-list" value={"ordered"} />
      <button className="ql-list" value={"bullet"} />
    </span>
    <span className="toolbar-grp">
      <button className="ql-indent" value={"-1"} />
      <button className="ql-indent" value={"+1"} />
      <select className="ql-align">
        <option value={"right"} />
        <option value={"center"} />
        <option value={"justify"} />
      </select>
    </span>
    <span className="toolbar-grp">
      <select className="ql-color" />
      <select className="ql-background" />
    </span>
    <span className="toolbar-grp">
      <button className="ql-link" />
      <button className="ql-image" />
    </span>
  </div>
);

// Add sizes to whitelist and register them
const Size = Quill.import("formats/size");

Size.whitelist = ["extra-small", "small", "medium", "large"];
Quill.register(Size, true);

// Add fonts to whitelist and register them
const Font = Quill.import("formats/font");

Font.whitelist = [
  "arial",
  "comic-sans",
  "courier-new",
  "georgia",
  "helvetica",
  "lucida",
];
Quill.register(Font, true);

/*
 * Editor component with custom toolbar and content containers
 */

const modules = {
  toolbar: {
    container: "#toolbar",
  },
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
];

const TextEditor = ({ value, onChange, placeholder }) => (
  <div className="text-editor">
    <CustomToolbar />
    <ReactQuill
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      modules={modules}
      formats={formats}
    />
  </div>
);

TextEditor.defaultProps = {
  value: "",
  onChange: () => {},
  placeholder: "",
};

TextEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default TextEditor;
